export default __webpack_public_path__ + "366f92eed4f87a3a5fc2699bfe81b99e.svg";